module.exports = __webpack_public_path__ + "static/media/alert.3580ee17.svg";